module.exports = __webpack_public_path__ + "img/harry_potter_04_and_the_goblet_of_fire_scan.0759707e.jpg";